import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useCreateCampaignMappingMutation, useListCampaignMappingsQuery, useDeleteCampaignMappingMutation  } from "../../redux/api/campaignMappings";
import { Table, Button, Form, Input, DatePicker, Typography, Space, message } from 'antd';

const CreationPage = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedClientRegion = 'ALL';

    const [form] = Form.useForm();

    const [createCampaignMapping, { isLoading: isCreating }] = useCreateCampaignMappingMutation();
    const listCampaignMappings = useListCampaignMappingsQuery({ clientName: selectedClient, clientRegion: selectedClientRegion });
    const [deleteCampaignMapping] = useDeleteCampaignMappingMutation();

    const columns = [
        {
            title: 'Config Name',
            dataIndex: 'config_name',
        },
        {
            title: 'Delete',
            key: 'delete',
            render: (_, record) => (
                <Button danger onClick={() => handleDeleteCampaignMapping(record)}>Delete</Button>
            ),
        }
    ];

    const handleCreateCampaignMapping = async (values) => {

        const body = {
            client_name: selectedClient,
            client_region: selectedClientRegion,
            config_name: values.config_name
        };
        try {
            await createCampaignMapping({ body }).unwrap();
            message.success('Campaign mapping created');
            form.resetFields();
        } catch (error) {
            message.error('Failed to create campaign mapping.');
        }
    };

    const handleDeleteCampaignMapping = async (record) => {
        try {
            await deleteCampaignMapping({ body: { client_name: selectedClient, client_region: selectedClientRegion, config_name: record.config_name } }).unwrap();
            message.success('Campaign mapping deleted');
        } catch (error) {
            message.error('Failed to delete campaign mapping.');
        }
    };
    return (
        <div style={{
            width: '100%',
        }}>
            <h3>Campaign Mappings</h3>
            <Table style={{
                width: '100%',
            }}
                dataSource={listCampaignMappings.data} columns={columns} />
            <br />
            <Form className="flexible-container" form={form} layout="vertical" onFinish={handleCreateCampaignMapping}>
                <h3>Create Campaign Mapping</h3>
                <Form.Item label="Config Name" name="config_name" rules={[{ required: true, message: 'Config name is required' }]}>
                    <Input placeholder="Config Name" />
                </Form.Item>
                <Button type="primary" htmlType="submit" loading={isCreating}>Create</Button>
            </Form>
        </div>
    );


};


export default CreationPage;